<script>
import ItemIndex from "../../abstract/ItemIndex.js";

export default ItemIndex.extend({
  data() {
    return {
      options: {
        academic: "any"
      },
      endpoint: "/api/departments",
      default: {
        academic: false
      },
      users: [],
      aggregateField: "employees_count",
      messages: {
        remove: {
          title: "Удаление отдела",
          message:
            "Вы действительно хотите удалить данный отдел?<br>" +
            "Все пользователи автоматически будут исключены из данного отдела.",
          confirm: "Удалить отдел",
          cancel: "Отмена",
          success: "Отдел был успешно удален"
        }
      }
    };
  },
  methods: {
    mergeOptions: function(options) {
      if (this.options.academic !== "any") {
        return _.merge(options, {
          academic: this.options.academic
        });
      } else {
        return options;
      }
    },
    beforeOpen(item) {
      if (!item) {
        return new Promise(resolve => {
          resolve();
        });
      }

      return new Promise((resolve, reject) => {
        this.loading = true;
        axios
          .get(`/api/departments/${item.id}/employees`)
          .then(response => {
            this.users = [];
            response.data.data.forEach(user => {
              this.users.push(user);
            });
            this.loading = false;
            resolve();
          })
          .catch(error => {
            this.loading = false;
            this.toast("error", "@unexpected", error);
            reject();
          });
      });
    },
    openUserProfile: function(user) {
      window.open(user.url, "_self");
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/departments/Index.vue